module.exports = __webpack_public_path__ + "resources/img/img_rancher2_m_en.d4b4c69caba4d561f71c587cb00ea21e.png";